<template>
  <div>
    <title-bar :title-stack="titleStack" />
    <b-loading
      :is-full-page="true"
      :active="isLoading"
    />
    <section class="section is-main-section">
      <card-component
        class="has-table has-mobile-sort-spaced"
        title="Cursanti"
        icon="account-school"
      >
        <refresh-button slot="button" />
        <card-toolbar slot="toolbar">
          <div
            slot="left"
            class="buttons has-addons"
          >
            <router-link
              :to="{name:'student.new'}"
              class="button is-primary"
            >
              Cursant nou
            </router-link>
          </div>
        </card-toolbar>
        <students-table-sample
          v-if="students.length > 0"
          :students="students"
          @handleDeleteStudent="handleDeleteStudent"
        />
        <students-table-sample
          v-else
          is-empty
        />
      </card-component>
    </section>
  </div>
</template>

<script>
import { reactive } from '@vue/composition-api'
import StudentsTableSample from '@/components/StudentsTableSample.vue'
import CardComponent from '@/components/CardComponent.vue'
import TitleBar from '@/components/TitleBar.vue'
import RefreshButton from '@/components/RefreshButton.vue'
import CardToolbar from '@/components/CardToolbar.vue'
import StudentService from '@/services/students.service'

export default {
  name: 'Students',
  components: { CardToolbar, RefreshButton, TitleBar, CardComponent, StudentsTableSample },
  setup (props, { root: { $buefy } }) {
    const titleStack = ['Linguapro', 'Cursanti']

    return {
      students: reactive([]),
      titleStack,
      isLoading: false
    }
  },
  async created () {
    this.isLoading = true
    this.getAllStudents().then((response) => {
      this.students = response
      this.isLoading = false
    })
  },
  methods: {
    async getAllStudents () {
      const { getStudents } = StudentService
      const response = await getStudents()
      const { data } = response
      return data
    },
    async handleDeleteStudent (id) {
      const { deleteStudent } = StudentService
      const response = await deleteStudent(id)
      const { status } = response
      if (status === 200) {
        const index = this.students.findIndex((prop) => prop.id === id)
        this.students.splice(index, 1)
        this.$buefy.snackbar.open({
          message: 'Inregistrea a fost stearsa.',
          queue: false
        })
      } else {
        this.$buefy.snackbar.open({
          message: 'Eroare la stergerea inregistrarii.',
          queue: false
        })
      }
    }
  }
}
</script>
